// import {useParams} from "react-router-dom";
import { useOAuth2 } from "@tasoskakour/react-use-oauth2";
import StartComponent from "./StartComponent";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
// import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {React, useEffect, useState, forwardRef} from "react";
import Slide from "@material-ui/core/Slide";
import {withStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {useTranslation} from "react-i18next";
import loginData from "../data/loginData.json";
import bcrypt from 'bcryptjs-react';


export default function MyLoginComponent(){

    const params = window.planerParams;
    const [resetDialogOpen, setResetDialogOpen] = useState(true);
    const {t, i18n} = useTranslation();
    const Transition = forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
    const [params2] = useState(loadParams(params));
    let errorText = false;
    // const salt = bcrypt.genSaltSync(12);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [darf, setDarf] = useState(true);
    const [isPrivat, setIsPrivat] = useState(false);

    let loggedInUser = localStorage.getItem("loggedInUser");
    let loggedInExpire = localStorage.getItem("loggedInUserExpire");
    let loggedInDOI = localStorage.getItem("loggedInUserDOI") && (localStorage.getItem("loggedInUserDOI") === 'true' || localStorage.getItem("loggedInUserDOI") === true) ? true : false;

    if (!['home-configurator','knx-configurator','switch-configurator'].includes(params.confType)) {
        const currentLocation = window.location.toString();
        if (params.confType.indexOf('knx') >= 0) { window.location = currentLocation.replace(params.confType,'knx-configurator'); }
        else if (params.confType.indexOf('home') >= 0) { window.location = currentLocation.replace(params.confType,'home-configurator'); }
        else if (params.confType.indexOf('switch') >= 0) { window.location = currentLocation.replace(params.confType,'switch-configurator'); }
        else { window.location = currentLocation.replace(params.confType,'knx-configurator'); }
    }
    // console.log('params mylogin', params)

    useEffect(() => {
        // Updating local storage if theme state is changed
        localStorage.setItem("loggedInUser", loggedInUser);
        localStorage.setItem("loggedInUserExpire", loggedInExpire);
        localStorage.setItem("loggedInUserDOI", loggedInDOI);
    }, []);

    if (loggedInUser !== null && loggedInExpire !== null && loggedInUser !== 'null' && loggedInExpire !== 'null') {
        // console.log('checktime', loggedInExpire, new Date().valueOf(), loggedInExpire === 'null');
        if (loggedInExpire < new Date().valueOf()) {
            loggedInUser = null; loggedInExpire = null;
            localStorage.setItem("loggedInUser", loggedInUser);
            localStorage.setItem("loggedInUserExpire", loggedInExpire);
            localStorage.setItem("loggedInUserDOI", false);
            setUserLoggedIn(false);
        } else {
            let lData;
            // eslint-disable-next-line
            loginData.some(d => {if (d.lang === params2.lang) { lData = d; } });
            // console.log('logindata', loginData, params2.lang, loggedInUser, lData, lData.username)
            if (lData && lData.username === loggedInUser) {
                if (!userLoggedIn) { setUserLoggedIn(true); }
            } else if (userLoggedIn) { setUserLoggedIn(false); }
        }
    } else if (userLoggedIn) { setUserLoggedIn(false); }
    // console.log('loggedinuser', loggedInUser, loggedInExpire, userLoggedIn)
    // const getIsMyJung = function() {
    //     if (document.location.pathname.indexOf('/myjung')) {
    //         return true;
    //     }
    //     return false;
    // };
    const getConfigurator = function(p) {
        var configurator = 'JUNG Home Konfigurator';
        if(p.confType) {
            switch (p.confType) {
                case 'home-configurator': configurator = 'JUNG HOME Konfigurator'; break;
                case 'switch-configurator': configurator = 'JUNG Schalter Konfigurator'; break;
                case 'knx-configurator': configurator = 'JUNG KNX Konfigurator'; break;
                default: configurator = 'JUNG HOME Konfigurator'; break;
            }
        }
        // configurator += getIsMyJung() ? ' (myJUNG)' : ' (B2B)';
        console.log('configurator set to', configurator);
        return configurator;
    };
    const authUrl = process.env.REACT_APP_QUICK_OAUTH2_AUTHORIZE_URL || 'https://oauth-stage.jung2023.twocream.com';
    const bckURL = process.env.REACT_APP_QUICK_BACKEND_URL || 'https://fs-conf3-jung-dev.p14.de';
// eslint-disable-next-line
    const { data, loading, error, getAuth, logout, isPersistent } = useOAuth2({
        authorizeUrl: authUrl + '/authorize',
        clientId: getClientId(),
        redirectUri: document.location.origin + '/de/' + params.confType + '/myjung/callback',
        // scope: "my-jung-info",
        scope: "my-jung-business-info",
        responseType: "code",
        exchangeCodeForTokenServerURL: bckURL + "/configurator-api/quickplaner/OAuth2/token",
        exchangeCodeForTokenMethod: "POST",
        onSuccess: (payload) => console.log("Success", payload),
        onError: (error_) => console.log("Error", error_)
    });

    const configurator = getConfigurator(params);
    const evalanceEndPoint = process.env.MY_JUNG_EVALANCHE_EINWILLIGUNG_ENDPOINT || 'https://service.entergon.cloud/evalanche/customers/jung/api/configurator_check_permission_dev.php';
    const isLanguage = ['nl','at','es'].some(v => v === params2.lang);
    let isLoggedIn = (!isLanguage && Boolean(data?.access_token)) || (isLanguage && userLoggedIn); // or whatever...
    // eslint-disable-next-line
    const myjungId = process.env.MY_JUNG_CLIENT_ID || 'jung-configurator-knx-pro';
console.log('params', params, 'configurator', configurator, 'endpoint', evalanceEndPoint);

    function loadParams(params){
        // console.log('params', params)
        // eslint-disable-next-line
        // let oldUrl = params.lang == undefined;
        if(params.confType !== undefined){
            if (params.lang !== undefined) {
                if (!['de','en','nl','at','it','fr','es'].includes(params.lang)) {
                    params = {
                        ...params,
                        code: params.confType,
                        confType: params.lang,
                        lang: i18n.resolvedLanguage
                    };
                    // oldUrl = true;
                }
            }
            const lang = params.lang ? params.lang : 'de';
            return {lang: lang};
        }
    }
    // console.log('logindata', loginData, params2.lang);
    const ColorButton = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--color1)",
            '&:hover': {
                backgroundColor:"#8cadbf",
                borderColor: "#8cadbf"
            },
            borderRadius: 0,
            width: "143px",
            height: "45px",
            lineHeight: "45px",
            fontSize: "20px",
            textAlign: "center",
            margin: "20px",
            textTransform: "inherit",
            padding: "8px 16px"
        },
    }))(Button);

    function getClientId(){
        switch(params.confType) {
            case "schalter":
            case "switch-configurator":
                return  "jung-configurator-switch";
            case "home":
            case "home-configurator":
                return "jung-configurator-home";
            case "knx":
            case "knx-configurator":
                return "jung-configurator-knx";
            default:
                return null;
        }
    }
    function renderSwitch() {
        console.log('isloggedin', isLoggedIn, params2.lang)
        switch(true) {
            case isLoggedIn:
                console.log('oauth data', data, params2.lang);
                // var darf = true;
                // const authName = process.env.MY_JUNG_EVALANCHE_AUTH_NAME || 'knx_test';
                // const authKey = process.env.MY_JUNG_EVALANCHE_AUTH_KEY || 'GL7!Fa4w6gEGFfh#+DZQvHH';
                // const authUrl = process.env.REACT_APP_QUICK_OAUTH2_AUTHORIZE_URL || 'https://oauth-stage.jung2023.twocream.com';
                const bckURL = process.env.REACT_APP_QUICK_BACKEND_URL || 'https://fs-conf3-jung-dev.p14.de';
                const selfUrl = process.env.REACT_APP_QUICK_SELF_URL || 'https://planung.fs-conf3-jung-dev.p14.de';
                const myjungId = data ? data.access_token : null;

                if (params2.lang !== 'de') {
                    return <StartComponent isMyJung={true} darf={true}/>;
                }

                var formData = new FormData();
                formData.append('configurl', bckURL);
                formData.append('myjungid', myjungId);
                formData.append('configurator', configurator);

                // var fetchOptions = {
                //     method: 'POST',
                //     headers: {
                //         'Authorization': 'Basic ' + btoa(authName + ":" + authKey),
                //         'Content-Type': 'multipart/form-data',
                //     },
                //     body: formData
                // };
                // console.log('fetching with options', fetchOptions)
                // fetch(bckURL, fetchOptions).then(function(res) {
                //     console.log('resp', res);
                //     if (res.status && res.status === 'success') {
                //         if (res.code && res.code === '0x0') {
                //             darf = true;
                //         }
                //     }
                // })
                if (!loggedInDOI) {
                    var apiURL = bckURL + '/configurator-api/quickplaner/evalanche_doi?url=' + selfUrl
                        + '&token=' + data.access_token
                        + '&url=' + bckURL
                        + '&configurator=' + configurator;
                    fetch(apiURL).then(resp => resp.json()).then(json => {
                        console.log('json', json);
                        loggedInDOI = true;
                        localStorage.setItem("loggedInUserDOI", loggedInDOI);
                        if (json.success !== undefined && (json.success === false || json.success === 'false')) {
                            loggedInDOI = false;
                            localStorage.setItem("loggedInUserDOI", loggedInDOI);
                            if (json.privat !== undefined && (json.privat === true || json.privat === 'true')) {
                                setIsPrivat(true);
                            }
                            setDarf(false);
                        }
                    });
                }
                console.log('starting component StartComponent mit darf=', darf);
                const DOIActive =
                    (process.env.REACT_APP_DOI_ACTIVE
                        && (
                            process.env.REACT_APP_DOI_ACTIVE === 'true' ||
                            process.env.REACT_APP_DOI_ACTIVE === true ||
                            process.env.REACT_APP_DOI_ACTIVE === '1' ||
                            process.env.REACT_APP_DOI_ACTIVE === 1
                        )
                    ) ? true : false;
                console.log('DOIActive', DOIActive, 'darf', darf)
                return DOIActive
                    ? <StartComponent isMyJung={true} darf={darf} isPrivat={isPrivat}/>
                    : <StartComponent isMyJung={true} darf={true} isPrivat={isPrivat}/>;
            default:
                const showLogin = ['nl','at','es'].some(v => v === params2.lang);
                if (i18n.language !== params2.lang) {i18n.changeLanguage(params2.lang);}
                // console.log('showlogin', showLogin, params2.lang,i18n.language)
                const create_account_url = process.env.REACT_APP_JUNG_CREATE_ACCOUNT_URL || 'https://www.jung-group.com/de-DE/account/login';
                if (!showLogin) {
                    return <>
                        <StartComponent isMyJung={true}/>
                        <div style={{
                            filter: "blur(4px)",
                            pointerEvents: "none",
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            background: 'rgba(255, 255, 255, 0.75)',
                            zIndex: 998
                        }}></div>
                        <Dialog
                            open={resetDialogOpen}
                            TransitionComponent={Transition}
                            keepMounted
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent>
                                <div style={{display: 'flex', flexDirection: 'column', padding: '20px 65px 0'}}>
                                    <p style={{textAlign: 'left', color: '#707070', fontSize: '32px'}}>
                                        {t('app.myJung.login')}
                                    </p>
                                    <p style={{
                                        textAlign: 'left',
                                        color: '#707070',
                                        fontSize: '20px',
                                        lineHeight: '26px'
                                    }}>
                                        {t('app.myJung.text')} <a className={"link-jung"}
                                                                  href={create_account_url}
                                                                  target={"_blank"}
                                                                  rel={"noreferrer"}
                                                                  style={{
                                                                      color: '#5b8aa4',
                                                                      textDecoration: 'none'
                                                                  }}>{t('app.myJung.linkText')}</a>.
                                    </p>
                                </div>
                                <div style={{
                                    textAlign: 'right',
                                    paddingBottom: '40px',
                                    paddingRight: '65px'
                                }}>{renderSwitch2()}</div>
                            </DialogContent>
                        </Dialog>
                        {/*<div style={{position: "fixed", top: "0", left: "0", right: '0', bottom: '0', zIndex: 999, display: 'flex', alignItems: 'flex-start'}}>*/}
                        {/*    <div style={{margin: "15% auto auto", width: "30%", background: "#5B8AA4", padding: "50px", textAlign: "center"}}>*/}
                        {/*        <p>*/}
                        {/*            myJUNG Login*/}
                        {/*        </p>*/}
                        {/*        {renderSwitch2()}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </>;
                } else {
                    const loginStyle = ".errorText{position:absolute;top:-10px;color:red;text-align:left;}.form-row {display: flex;flex-flow: row wrap;margin-top: -10px;margin-bottom: 14px;}.form-row .form-row__col {margin: 10px 0;}.form-row .col-12 {flex: 0 0 100%;max-width: 100%;}.form-label {position: absolute;display: inline-block;margin: 0;color: #c9c9c9;font-size: 20px;font-weight: 400; -ms-transform: translateY(13px); -webkit-transform: translateY(13px);transform: translateY(13px); -webkit-transition: all .33s;transition: all .33s;}.form-group.is-completed .form-label { -ms-transform: translateY(-18px); -webkit-transform: translateY(-18px);transform: translateY(-18px);font-size: 16px;}.form-control::placeholder{opacity:0.5;}.form-control {display: block;width: 100%;height: calc(1.5em + 1.125rem + 2px);margin: 0;background-color: #ffffff; -webkit-background-clip: padding-box;background-clip: padding-box;border: 1px solid #707070;border-top: none;border-right: none;border-left: none;border-radius: 0;padding: 0;color: #707070;font-size: 20px;line-height: 32px;font-weight: 400; -webkit-box-shadow: inset 10px 10px 300px 200px #fff !important; -moz-box-shadow: inset 10px 10px 300px 200px #fff !important;box-shadow: inset 10px 10px 300px 200px #fff !important;overflow: visible; -webkit-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;}.form-control:focus {color: #707070;background-color: #ffffff;border-color: #5b8aa4;outline: 0;}";
                    return <>
                        <StartComponent isMyJung={true}/>
                        <div style={{
                            filter: "blur(4px)",
                            pointerEvents: "none",
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            background: 'rgba(255, 255, 255, 0.75)',
                            zIndex: 998
                        }}></div>
                        <style>{loginStyle}</style>
                        <Dialog
                            open={resetDialogOpen}
                            TransitionComponent={Transition}
                            keepMounted
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent>
                                <div style={{display: 'flex', flexDirection: 'column', padding: '20px 65px 0'}}>
                                    <p style={{textAlign: 'left', color: '#707070', fontSize: '32px'}}>{t('app.login.title')}</p>
                                    <p style={{textAlign: 'left', color: '#707070', fontSize: '20px', lineHeight: '26px'}}>{t('app.login.text')}</p>
                                    <div className="login-form__inputs form-row">
                                        <div className="form-group form-row__col col-12 col-md-6">
                                            {/*<label className="form-label" htmlFor="userName">{t('app.login.username')}</label>*/}
                                            <input type="text" className="form-control" id="userName" name="userName" placeholder={t('app.login.username')} />
                                        </div>
                                        <div className="form-group form-row__col col-12 col-md-6">
                                            {/*<label className="form-label" htmlFor="userPassword">{t('app.login.password')}</label>*/}
                                            <input type="password" className="form-control" id="userPassword" name="userPassword" required="required" autoComplete="off" placeholder={t('app.login.password')} />
                                        </div>
                                    </div>
                                    {/*<input type="text" id="userName" name="userName" value={userName} onChange={setUserName} placeholder={t('app.login.username')} />*/}
                                    {/*<input type="text" id="userPassword" name="userPassword" value={userPassword} onChange={setUserPassword} placeholder={t('app.login.password')} />*/}
                                </div>
                                <div style={{textAlign: 'right', paddingBottom: '40px', paddingRight: '65px', paddingLeft: '65px', position:'relative'}}>
                                    <div id="errorText" className="errorText" style={{opacity:0}}>{t('app.login.error')}</div>
                                    {renderSwitch2(true)}
                                </div>
                            </DialogContent>
                        </Dialog>
                    </>;
                }
        }
    }
    function checkLogin() {
        let userData; const passwdHash = '$2a$12$JE0r5ETOCbbDMIxa5jU8ZuQrntY7vkIIW8yGnvnpqNxOB8G8hxbvm';
        for(let i=0;i<loginData.length;i++){
            if (loginData[i].lang === params2.lang) { userData = loginData[i]; }
        }
        if (userData) {
            const userName = document.getElementById('userName').value;
            const userPassword = document.getElementById('userPassword').value;
            // console.log('userdata', userData, userName, userPassword)
            const hashed = bcrypt.hashSync(userPassword, '$2a$12$JE0r5ETOCbbDMIxa5jU8Zu');
            // console.log('hashed', hashed);
            // console.log('should', passwdHash)
            // console.log('salt', salt)
            if (hashed === passwdHash && userName === userData.username) {
                setUserLoggedIn(true);
                errorText = false;
                isLoggedIn = true;
                loggedInUser = userName;
                loggedInExpire = new Date().valueOf() + 14400000;
                localStorage.setItem("loggedInUser", loggedInUser);
                localStorage.setItem("loggedInUserExpire", loggedInExpire);
            }
        }
        document.getElementById('errorText').style.opacity = 1;
        errorText = true;
    }

    function renderSwitch2(showLogin = false){
        switch(true) {
            case isLoggedIn:
                return  <StartComponent isMyJung={true} />;
            case loading:
                return <div>Loading...</div>;
            case error:
                return <div>Error</div>;
            default:
                if (!showLogin) {
                    return <><ColorButton style={{margin: "24px 0", cursor: "pointer", borderRadius: '3px'}}
                                          type="button" className={"jung-button"}
                                          onClick={() => getAuth()}>Login</ColorButton></>;
                } else {
                    return <><ColorButton style={{margin: "24px 0", cursor: "pointer", borderRadius: '3px'}}
                                          type="button" className={"jung-button"}
                                          onClick={() => checkLogin()}>Login</ColorButton></>;
                }
        }

    }

    return <>{renderSwitch()}</>;
}
